import type { TFunction } from 'i18next';

// Преобразует машинный error_code сообщения в человекочитаемый текст через
// i18n (`messages.errors.<code>`). Если ключа в локалях нет — отдаём raw code
// без обёртки, чтобы оператор хотя бы видел диагностику.
//
// Используется и в MessageStatusTag (Tooltip), и в колонке «Текст ошибки»
// таблицы. Не несёт состояния — pure-функция.
export function errorCodeText(t: TFunction, code: string | null | undefined): string | null {
  if (!code) return null;
  const key = `messages.errors.${code}`;
  const translated = t(key);
  // i18next по умолчанию возвращает ключ как есть, если перевода нет.
  return translated === key ? code : translated;
}
